// 외치기 텍스트 세그먼트(run) 유틸 SSOT — 런타임(OverlayItem)·기즈모·인스펙터 공유.
//  textSchemas = [{ text, style: { color?, stroke? } }, ...] — 연속 동일 스타일 글자의 묶음(리치 텍스트 run).
//  기존 단일 요소 배열은 세그먼트 1개로 그대로 동작(하위호환). stroke = 폰트 외곽선 색.

export function segmentsOf(textSchemas) {
  const arr = Array.isArray(textSchemas) ? textSchemas : [];
  if (!arr.length) return [{ text: "", style: {} }];
  return arr.map((s) => ({ text: String(s.text || ""), style: s.style || {} }));
}

export function fullText(textSchemas) {
  return segmentsOf(textSchemas)
    .map((s) => s.text)
    .join("");
}

// 세그먼트 → 글자 <span> DOM 빌드 (색/stroke 세그먼트 상속, \n = <br>).
//  반환: 글자 span 배열 — textFx(타이핑/스크램블 stagger)의 대상.
export function buildCharSpans(el, textSchemas, { defaultColor = "white", defaultStroke = "black", strokeWidth = 1 } = {}) {
  el.innerHTML = "";
  const chars = [];
  segmentsOf(textSchemas).forEach((seg) => {
    const color = seg.style.color || defaultColor;
    const stroke = seg.style.stroke || defaultStroke;
    for (const ch of String(seg.text)) {
      if (ch === "\n") {
        el.appendChild(document.createElement("br"));
        continue;
      }
      const sp = document.createElement("span");
      sp.textContent = ch;
      sp.style.color = color;
      sp.style.webkitTextStroke = `${strokeWidth}px ${stroke}`;
      el.appendChild(sp);
      chars.push(sp);
    }
  });
  return chars;
}

// 세그먼트 → 정적 HTML (기즈모 미리보기 v-html용). 이스케이프 필수.
const esc = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
export function segmentsToHtml(textSchemas, { defaultColor = "white", defaultStroke = "black", strokeWidth = 1 } = {}) {
  return segmentsOf(textSchemas)
    .map((seg) => {
      const color = seg.style.color || defaultColor;
      const stroke = seg.style.stroke || defaultStroke;
      const body = esc(seg.text).replace(/\n/g, "<br>");
      return `<span style="color:${esc(color)};-webkit-text-stroke:${strokeWidth}px ${esc(stroke)}">${body}</span>`;
    })
    .join("");
}

// ── 글자별 편집 (인스펙터) ──
// 세그먼트 → 글자 단위 [{ch, style}] 평탄화 (\n 포함 — 위치 보존)
export function flattenChars(textSchemas) {
  const out = [];
  segmentsOf(textSchemas).forEach((seg) => {
    for (const ch of String(seg.text)) out.push({ ch, style: { ...seg.style } });
  });
  return out;
}

// 글자 배열 → 연속 동일 스타일 병합 세그먼트
export function mergeToSegments(chars) {
  const segs = [];
  chars.forEach(({ ch, style }) => {
    const last = segs[segs.length - 1];
    if (last && sameStyle(last.style, style)) last.text += ch;
    else segs.push({ text: ch, style: { ...style } });
  });
  return segs.length ? segs : [{ text: "", style: {} }];
}

function sameStyle(a = {}, b = {}) {
  return (a.color || "") === (b.color || "") && (a.stroke || "") === (b.stroke || "");
}

// [start, end] 범위(글자 인덱스, 양끝 포함)에 스타일 패치 적용 → 새 textSchemas
export function applyStyleToRange(textSchemas, start, end, patch) {
  const chars = flattenChars(textSchemas);
  const lo = Math.max(0, Math.min(start, end));
  const hi = Math.min(chars.length - 1, Math.max(start, end));
  for (let i = lo; i <= hi; i++) chars[i].style = { ...chars[i].style, ...patch };
  return mergeToSegments(chars);
}

// 전체에 스타일 패치 적용 (세그먼트 유지하며 해당 키만 덮어씀)
export function applyStyleToAll(textSchemas, patch) {
  return segmentsOf(textSchemas).map((seg) => ({ ...seg, style: { ...seg.style, ...patch } }));
}
